import React from "react";
import ctl from "@netlify/classnames-template-literals";

import { Text } from "components";
import { PLink } from "components/plink";

const PoliciesAndCopyright = () => {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <div className={policiesAndCopyrightWrapper}>
      {/* <Text variant="p14" color="secondary-900">
        &copy; Copyright {year}. Parkway Projects Limited is licensed by the
        Central Bank of Nigeria{" "}
      </Text> */}

      <Text variant="p14" color="secondary-900">
        &copy; Copyright {year}. Parkway Projects Limited is licensed by the
        Central Bank of Nigeria{" "}
      </Text>

      <div className={copyWrap}>
        <PLink to="/terms-of-service" className="mr-[10px]" underline>
          <Text variant="p14" value="Terms of Service" weight="500" />
        </PLink>

        <PLink to="/privacy-policy" className="mr-[10px]" underline>
          <Text variant="p14" value="Privacy Policy" weight="500" />
        </PLink>

        <PLink to="/security-policy" underline>
          <Text variant="p14" value="Security Policy" weight="500" />
        </PLink>
      </div>
    </div>
  );
};

const policiesAndCopyrightWrapper = ctl(`
flex
md:flex-row
flex-col
justify-between
md:mt-[66px]
mt-[36px]
md:pt-4
pt-3
border-t
border-secondary-700
gap-4
`);

const copyWrap = ctl(`flex`);

export { PoliciesAndCopyright };
